module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/connect-c6904bc003e68c00fcf1ef86926ed5a6.webp";